import { render, staticRenderFns } from "./AtTCCheckbox.vue?vue&type=template&id=4722bc7a&scoped=true&"
import script from "./AtTCCheckbox.vue?vue&type=script&lang=js&"
export * from "./AtTCCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4722bc7a",
  null
  
)

export default component.exports